<template>
  <div class="evaluation-result" :class="{ checkapp: platform === 'checkapp' }">
    <div class="evaluation-wrap">
      <div class="evaluation-result-icon expired"></div>
      <div class="result-info">
        <header>评价已过期</header>
        <p>{{ `感谢您对${platform === 'checkapp' ? '切克' : '转转'}的支持，该评价已过期` }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import { queryParams } from '../../lib/utils'

const query = queryParams()

export default {
  name: 'EvaluationExpired',
  data() {
    return {
      pagetype: query.pagetype || this.$route.query.pagetype,
      platform: native.client || 'zz' // 获取当前客户端平台，默认为转转
    }
  },
  created() {
    native.setTitle({
      title: '服务反馈评价'
    })

    native.wrap('resetRightAllButton')((_res) => {
      native.wrap('setRightUnifiedButton')(
        {
          label: '完成'
        },
        (res) => {
          if (Number(res.code) === 0) {
            native.close()
          }
        }
      )
    })
    if (this.pagetype === '1') {
      lego.send({
        pagetype: 'ZZUP_KEFU_STAR_EVALUATION_EXPIRED',
        actiontype: 'PAGE_SHOW'
      })
    } else {
      lego.send({
        pagetype: 'ZZUP_KEFUORDER_EVALUATION_EXPIRED',
        actiontype: 'PAGE_SHOW'
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import './Success.less';
</style>
